import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../../config';

export default function useProfileSummary() {
  const [state, setState] = useState({ status: 'loading', profile: null, reportsCount: null, managerName: null });
  const [attempt, setAttempt] = useState(0);
  const retry = useCallback(() => setAttempt((n) => n + 1), []);

  useEffect(() => {
    let active = true;
    setState((s) => ({ ...s, status: 'loading' }));
    const opts = { withCredentials: true };
    Promise.allSettled([
      axios.get(`${API_BASE_URL}/api/profile`, opts),
      axios.get(`${API_BASE_URL}/api/profile/reporting-line?summary=1`, opts),
    ]).then(([p, line]) => {
      if (!active) return;
      if (p.status !== 'fulfilled') { setState({ status: 'error', profile: null, reportsCount: null, managerName: null }); return; }
      const l = line.status === 'fulfilled' ? line.value.data : null;
      const reportsCount = l?.available && Array.isArray(l.reports) ? l.reports.length : null;
      // Direct manager = the entry just above self in the root-first chain,
      // named the way the directory names them (Nexus account name first).
      const chain = l?.available && Array.isArray(l.chain) ? l.chain : [];
      const selfAt = chain.findIndex((c) => c.is_self);
      const manager = selfAt > 0 ? chain[selfAt - 1] : null;
      const managerName = manager ? (manager.display_name || manager.name || null) : null;
      setState({ status: 'ready', profile: p.value.data, reportsCount, managerName });
    });
    return () => { active = false; };
  }, [attempt]);

  return { ...state, retry };
}
